module.exports = __webpack_public_path__ + "static/media/mac-coffee-photo.afc7931d.jpg";